import "./contact.css";

import React from "react";

import { CONTACT, CONTACT_FORM, SECTIONS } from "../../data/content";
import { postRequest } from "../../utils/apiHandlers";

const EMPTY = {
  name: "",
  email: "",
  subject: "",
  message: "",
  website: "", //Honeypot
};

//Grey "Contact Us" band at the bottom of every page: details, the enquiry form and a map
const ContactSection = () => {
  const [form, setForm] = React.useState(EMPTY);
  const [isSending, setIsSending] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");
  const [isSent, setIsSent] = React.useState(false);

  const update = (prop) => (e) => {
    setForm({ ...form, [prop]: e.target.value });
    setIsSent(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorText("");
    setIsSending(true);
    try {
      await postRequest("/Contact/SendMessage", form);
      setIsSent(true);
      setForm(EMPTY);
    }
    catch (err) {
      setErrorText(err.message);
    }
    setIsSending(false);
  };

  return (
    <section
      id={SECTIONS.CONTACT}
      className={"contact"}
      aria-labelledby={"contact-heading"}
    >
      <div className={"container"}>
        <h2
          id={"contact-heading"}
          className={"heading"}
        >
          {CONTACT_FORM.HEADING}
        </h2>

        <ul className={"contact-details"}>
          <li>
            <a href={`mailto:${CONTACT.EMAIL}`}>{CONTACT.EMAIL}</a>
          </li>
          <li>
            <a
              href={CONTACT.MAP_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              {CONTACT.ADDRESS}
            </a>
          </li>
          <li>
            <a href={`tel:${CONTACT.PHONE_LINK}`}>Tel: {CONTACT.PHONE}</a>
          </li>
        </ul>

        <form
          className={"contact-form"}
          onSubmit={onSubmit}
        >
          <label className={"contact-field"}>
            <span className={"contact-label"}>{CONTACT_FORM.NAME_LABEL}</span>
            <input
              type={"text"}
              value={form.name}
              onChange={update("name")}
              placeholder={CONTACT_FORM.NAME_PLACEHOLDER}
              maxLength={200}
              autoComplete={"name"}
            />
          </label>
          <label className={"contact-field"}>
            <span className={"contact-label"}>
              {CONTACT_FORM.EMAIL_LABEL} <span aria-hidden={"true"}>*</span>
            </span>
            <input
              type={"email"}
              value={form.email}
              onChange={update("email")}
              placeholder={CONTACT_FORM.EMAIL_PLACEHOLDER}
              required
              maxLength={200}
              autoComplete={"email"}
            />
          </label>
          <label className={"contact-field is-wide"}>
            <span className={"contact-label"}>{CONTACT_FORM.SUBJECT_LABEL}</span>
            <input
              type={"text"}
              value={form.subject}
              onChange={update("subject")}
              placeholder={CONTACT_FORM.SUBJECT_PLACEHOLDER}
              maxLength={200}
            />
          </label>
          <label className={"contact-field is-wide"}>
            <span className={"contact-label"}>{CONTACT_FORM.MESSAGE_LABEL}</span>
            <textarea
              value={form.message}
              onChange={update("message")}
              placeholder={CONTACT_FORM.MESSAGE_PLACEHOLDER}
              rows={6}
              maxLength={5000}
            />
          </label>

          <label
            className={"form-honeypot"}
            aria-hidden={"true"}
          >
            Website
            <input
              type={"text"}
              value={form.website}
              onChange={update("website")}
              tabIndex={-1}
              autoComplete={"off"}
            />
          </label>

          <button
            type={"submit"}
            className={"btn is-orange contact-submit is-wide"}
            disabled={isSending}
          >
            {isSending ? "Sending..." : CONTACT_FORM.SUBMIT}
          </button>

          <div
            className={"contact-status is-wide"}
            role={"status"}
            aria-live={"polite"}
          >
            {isSent ? <p className={"contact-success"}>{CONTACT_FORM.SUCCESS}</p> : null}
            {errorText ? <p className={"contact-error"}>{errorText}</p> : null}
          </div>
        </form>
      </div>

      <iframe
        className={"contact-map"}
        title={`Map: ${CONTACT.ADDRESS}`}
        src={CONTACT.MAP_EMBED}
        loading={"lazy"}
        referrerPolicy={"no-referrer-when-downgrade"}
      />
    </section>
  );
};

export default ContactSection;
